var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-cards" }, [
      _c(
        "div",
        { staticClass: "cards" },
        [
          _c("app-card-dashboard", {
            staticClass: "card-dashboard",
            attrs: {
              title: "Processos atrasados",
              content: _vm.infoPrazos.totalVencidos,
              icon: "fal fa-engine-warning",
              color: "#FF5D67"
            }
          }),
          _c("app-card-dashboard", {
            staticClass: "card-dashboard cardDashboardStyle",
            attrs: {
              title: "Processos prestes a atrasar",
              content: _vm.infoPrazos.totalAVencer,
              icon: "fal fa-alarm-exclamation",
              color: "#FFD36B"
            }
          }),
          _c("app-card-dashboard", {
            staticClass: "card-dashboard cardDashboardStyle",
            attrs: {
              title: "Processos em dia",
              content: _vm.infoPrazos.totalEmDia,
              icon: "fal fa-check-circle",
              color: "#11B88B"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-523e7863", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523e7863","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppRelatorioPrazos.vue
// module id = null
// module chunks = 